import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const FounderStory = () => {
  const founderData = {
    name: "Rajesh Kumar & Maria Gonzalez",
    title: "Co-Founders",
    image: "https://images.unsplash.com/photo-1729345422928-a53edc9dbd3b",
    imageAlt: "Two passionate restaurant founders standing together in modern kitchen wearing chef aprons, smiling warmly with authentic Mexican street food ingredients displayed on counter",
    story: `Our journey began in 2019 when Rajesh, a Bengaluru native with a passion for global cuisines, met Maria during a culinary expedition to Mexico City. Walking through the bustling streets of Coyoacán, they discovered something magical—the way street food brought communities together, transcending language and culture.\n\nMaria, whose grandmother ran a taco stand in Guadalajara for 40 years, shared stories of authentic recipes passed down through generations. Rajesh saw an opportunity to bring this authentic experience to Bengaluru, but with a crucial adaptation—ensuring every ingredient met halal standards without compromising on traditional flavors.\n\nWhat started as a small food cart in Indiranagar in 2020 has grown into a beloved destination for food lovers across Bengaluru. We've stayed true to our founding principle: authentic flavors, inclusive values, and genuine connections.`,
    values: [
    {
      icon: "Heart",
      title: "Authenticity First",
      description: "Traditional recipes with respect for cultural origins"
    },
    {
      icon: "Users",
      title: "Inclusive Community",
      description: "Creating spaces where everyone feels welcome"
    },
    {
      icon: "Leaf",
      title: "Fresh & Honest",
      description: "No shortcuts, no compromises on quality"
    },
    {
      icon: "Award",
      title: "Halal Certified",
      description: "100% halal ingredients with full transparency"
    }]

  };

  return (
    <section className="py-20 bg-card">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-4xl sm:text-5xl font-bold text-foreground mb-4">
            Our <span className="text-primary">Story</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            A tale of two cultures, one passion, and countless tacos
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div className="animate-slide-up">
            <div className="relative rounded-2xl overflow-hidden shadow-lg">
              <Image
                src={founderData?.image}
                alt={founderData?.imageAlt}
                className="w-full h-[500px] object-cover" />

              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                <h3 className="text-2xl font-bold text-white mb-1">{founderData?.name}</h3>
                <p className="text-white/90">{founderData?.title}</p>
              </div>
            </div>
          </div>

          <div className="animate-slide-up space-y-6">
            {founderData?.story?.split('\n\n')?.map((paragraph, index) =>
            <p key={index} className="text-lg text-foreground/80 leading-relaxed">
                {paragraph}
              </p>
            )}
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {founderData?.values?.map((value, index) =>
          <div
            key={index}
            className="bg-background p-6 rounded-xl border border-border hover:border-primary transition-all duration-300 hover:shadow-md animate-fade-in"
            style={{ animationDelay: `${index * 100}ms` }}>

              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                <Icon name={value?.icon} size={24} color="var(--color-primary)" />
              </div>
              <h4 className="text-lg font-semibold text-foreground mb-2">{value?.title}</h4>
              <p className="text-muted-foreground">{value?.description}</p>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default FounderStory;